import { AppContext } from '@galigeo-store/ui-lib';

export class PortalAppContext extends AppContext {
  static setBackendUrl(backendUrl: any) {
    AppContext.setBackendUrl(
      backendUrl ?? import.meta.env?.VITE_BACKEND_URL ?? '.'
    );
  }

  static setTrackerUrl() {
    const trackerUrl = import.meta.env?.VITE_TRACKER_URL;
    if (trackerUrl) {
      AppContext.setTrackerUrl(trackerUrl);
    }
  }

  static getAppConfiguration() {
    return AppContext.getFromContext('configuration');
  }

  static setAppConfiguration(configuration: any) {
    AppContext.addToContext('configuration', configuration);
  }

  static setLicenseExpired(expired: boolean) {
    AppContext.addToContext('licenseExpired', expired);
  }

  static isLicenseExpired(): boolean {
    return AppContext.getFromContext('licenseExpired') ?? false;
  }

  static setMaps(maps: any[]) {
    AppContext.addToContext('maps', maps);
  }

  static getMaps(): any[] {
    return AppContext.getFromContext('maps') ?? [];
  }
}
